import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const uiStore = {
    actionCreators,
    reducer,
};

export default uiStore;
